// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ngw-feature-attachment-carousel-render {
  flex: 1;
  min-height: 0;
  pointer-events: none;
}
.ngw-feature-attachment-carousel-render > .slick-slider {
  height: 100%;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-arrow {
  z-index: 100;
  margin-top: -16px;
  width: 32px;
  height: 32px;
  pointer-events: auto;
  color: rgba(255, 255, 255, 0.25);
  font-size: 32px;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-arrow > .icon {
  position: absolute;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-arrow:hover {
  color: white;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-arrow::after {
  content: unset;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-arrow.slick-prev {
  left: 8px;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-arrow.slick-next {
  right: 8px;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-list {
  height: 100%;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-list > .slick-track {
  height: 100%;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-list > .slick-track > .slick-slide {
  height: 100%;
  pointer-events: none;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-list > .slick-track > .slick-slide > div {
  box-sizing: border-box;
  padding: 48px;
  padding-top: 0;
  height: 100%;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-list > .slick-track > .slick-slide > div > .ant-image {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-list > .slick-track > .slick-slide > div > .ant-image > img {
  display: block;
  width: unset;
  max-width: 100%;
  height: unset;
  max-height: 100%;
  pointer-events: auto;
}
.ngw-feature-attachment-carousel-render > .slick-slider > .slick-dots-bottom {
  position: absolute;
  bottom: 20px;
  pointer-events: auto;
}
.ngw-feature-attachment-carousel-render > .ant-tooltip-btn {
  pointer-events: auto;
}
.ngw-feature-attachment-carousel-render-toolbar {
  display: flex;
  justify-content: end;
  align-items: start;
  gap: 8px;
  z-index: 1100;
  margin-right: 48px;
  margin-left: 48px;
  min-height: 48px;
  pointer-events: auto;
  color: white;
}
.ngw-feature-attachment-carousel-render-toolbar > div.title {
  flex: 1;
  align-self: center;
  margin: 4px 0;
}
.ngw-feature-attachment-carousel-render-toolbar > div.title > .filename {
  color: rgba(255, 255, 255, 0.25);
}
.ngw-feature-attachment-carousel-render-toolbar > .ant-btn {
  margin-top: 8px;
  padding: 0;
  width: 32px;
  height: 32px;
  pointer-events: auto;
  color: rgba(255, 255, 255, 0.25);
  font-size: 24px;
  line-height: 0;
}
.ngw-feature-attachment-carousel-render-toolbar > .ant-btn.toggle-on {
  color: white;
}
.ngw-feature-attachment-carousel-render-toolbar > .ant-btn .ant-btn-icon:hover {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/feature_attachment/nodepkg/image-thumbnail/component/CarouselRender.less"],"names":[],"mappings":"AAAA;EACI,OAAA;EACA,aAAA;EACA,oBAAA;AACJ;AAJA;EAMQ,YAAA;AACR;AAPA;EASY,YAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;AACZ;AAhBA;EAkBgB,kBAAA;AAChB;AAEY;EACI,YAAA;AAAhB;AAGY;EACI,cAAA;AADhB;AAIY;EAGI,SAAA;AAJhB;AAOY;EACI,UAAA;AALhB;AA/BA;EAyCY,YAAA;AAPZ;AAlCA;EA4CgB,YAAA;AAPhB;AArCA;EA+CoB,YAAA;EACA,oBAAA;AAPpB;AAzCA;EAmDwB,sBAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;AAPxB;AA/CA;EAyD4B,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAP5B;AArDA;EA+DgC,cAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,oBAAA;AAPhC;AA7DA;EA6EY,kBAAA;EACA,YAAA;EACA,oBAAA;AAbZ;AAlEA;EAoFQ,oBAAA;AAfR;AAmBA;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;AAjBJ;AAOA;EAaQ,OAAA;EACA,kBAAA;EACA,aAAA;AAjBR;AAEA;EAkBY,gCAAA;AAjBZ;AADA;EAuBQ,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;AAnBR;AAqBQ;EACI,YAAA;AAnBZ;AAdA;EAqCY,YAAA;AApBZ","sourcesContent":[".ngw-feature-attachment-carousel-render {\n    flex: 1;\n    min-height: 0;\n    pointer-events: none;\n\n    > .slick-slider {\n        height: 100%;\n\n        > .slick-arrow {\n            z-index: 100;\n            margin-top: -16px;\n            width: 32px;\n            height: 32px;\n            pointer-events: auto;\n            color: rgba(255, 255, 255, 0.25);\n            font-size: 32px;\n\n            > .icon {\n                position: absolute;\n            }\n\n            &:hover {\n                color: white;\n            }\n\n            &::after {\n                content: unset;\n            }\n\n            &.slick-prev {\n                // It may look wrong aligned, here is the details:\n                // https://github.com/google/material-design-icons/issues/1744\n                left: 8px;\n            }\n\n            &.slick-next {\n                right: 8px;\n            }\n        }\n\n        > .slick-list {\n            height: 100%;\n\n            > .slick-track {\n                height: 100%;\n\n                > .slick-slide {\n                    height: 100%;\n                    pointer-events: none;\n\n                    > div {\n                        box-sizing: border-box;\n                        padding: 48px;\n                        padding-top: 0;\n                        height: 100%;\n\n                        > .ant-image {\n                            display: flex;\n                            justify-content: center;\n                            align-items: center;\n                            height: 100%;\n\n                            > img {\n                                display: block;\n                                width: unset;\n                                max-width: 100%;\n                                height: unset;\n                                max-height: 100%;\n                                pointer-events: auto;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        > .slick-dots-bottom {\n            position: absolute;\n            bottom: 20px;\n            pointer-events: auto;\n        }\n    }\n\n    > .ant-tooltip-btn {\n        pointer-events: auto;\n    }\n}\n\n.ngw-feature-attachment-carousel-render-toolbar {\n    display: flex;\n    justify-content: end;\n    align-items: start;\n    gap: 8px;\n    z-index: 1100;\n    margin-right: 48px;\n    margin-left: 48px;\n    min-height: 48px;\n    pointer-events: auto;\n    color: white;\n\n    > div.title {\n        flex: 1;\n        align-self: center;\n        margin: 4px 0;\n\n        > .filename {\n            color: rgba(255, 255, 255, 0.25);\n        }\n    }\n\n    > .ant-btn {\n        margin-top: 8px;\n        padding: 0;\n        width: 32px;\n        height: 32px;\n        pointer-events: auto;\n        color: rgba(255, 255, 255, 0.25);\n        font-size: 24px;\n        line-height: 0;\n\n        &.toggle-on {\n            color: white;\n        }\n\n        .ant-btn-icon:hover {\n            color: white;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
